import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [servicesOpen, setServicesOpen] = useState(false);
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
        setServicesOpen(false);
    };

    return (
        <>
            {/* Mobile overlay */}
            <div
                className={`mobile-menu-overlay ${mobileMenuOpen ? 'active' : ''}`}
                onClick={closeMobileMenu}
            ></div>

            <nav className="navbar">
                <div className="navbar-container">
                    <div className="navbar-brand">
                        <Link to="/" onClick={closeMobileMenu} className="brand-link">
                            <img src="/logo.png" alt="OnOneGroup" className="brand-logo" />
                        </Link>
                    </div>

                    <div className="navbar-right">
                        <ul className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
                            <li>
                                <Link
                                    to="/"
                                    className={isActive('/') ? 'active' : ''}
                                    onClick={closeMobileMenu}
                                >
                                    Home
                                </Link>
                            </li>

                            <li className={`nav-dropdown ${servicesOpen ? 'active' : ''}`}>
                                <span
                                    className="nav-dropdown-trigger"
                                    onClick={() => setServicesOpen(!servicesOpen)}
                                    role="button"
                                    tabIndex={0}
                                >
                                    Services ▾
                                </span>
                                <div className="nav-dropdown-menu">
                                    <div className="nav-dropdown-section">
                                        <span className="nav-dropdown-label">Tech Services</span>
                                        <Link to="/ai-services" onClick={closeMobileMenu} style={{ fontWeight: 600, color: 'var(--color-accent-secondary)' }}>AI & Automation ✨</Link>
                                        <Link to="/web-development" onClick={closeMobileMenu}>Web Development</Link>
                                        <Link to="/it-consulting" onClick={closeMobileMenu}>IT Consulting</Link>
                                        <Link to="/software" onClick={closeMobileMenu}>Software Solutions</Link>
                                        <Link to="/app-development" onClick={closeMobileMenu}>App Development</Link>
                                    </div>
                                    <div className="nav-dropdown-divider"></div>
                                    <div className="nav-dropdown-section">
                                        <span className="nav-dropdown-label">Investment Services</span>
                                        <Link to="/real-estate" onClick={closeMobileMenu}>Real Estate</Link>
                                        <Link to="/investing" onClick={closeMobileMenu}>Investing</Link>
                                    </div>
                                </div>
                            </li>

                            <li>
                                <Link
                                    to="/about"
                                    className={isActive('/about') ? 'active' : ''}
                                    onClick={closeMobileMenu}
                                >
                                    About
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/contact"
                                    className={`btn btn-primary btn-sm ${isActive('/contact') ? 'active' : ''}`}
                                    onClick={closeMobileMenu}
                                >
                                    Contact Us
                                </Link>
                            </li>
                        </ul>

                        <button
                            className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
                            onClick={toggleMobileMenu}
                            aria-label="Toggle menu"
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;